import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { track } from "@/lib/track";
import { klaviyoIdentify } from "@/lib/klaviyo";

export const LeadCapture = ({ source = "site" }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!api) return;
    setBusy(true);
    try {
      await api.post("/leads", { email, source });
      setDone(true);
      klaviyoIdentify(email);
      track("generate_lead", { source });
    } catch (err) {
      toast.error("Please check your email address");
    }
    setBusy(false);
  };

  if (done) {
    return (
      <div data-testid="lead-success" className="border border-line bg-[#0b0b0b] p-6">
        <p className="eyebrow">You are in</p>
        <p className="font-display mt-3 text-2xl text-white">Check your inbox.</p>
        <p className="mt-2 text-sm text-zinc-300">Your personal 10% code is on its way to {email}. Enter it at checkout.</p>
      </div>
    );
  }

  return (
    <div>
    <form onSubmit={submit} data-testid="lead-form" className="flex flex-col gap-3 sm:flex-row">
      <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address"
        data-testid="lead-email-input"
        className="h-14 w-full sm:flex-1 border border-line bg-[#121212] px-5 text-white placeholder:text-zinc-500 outline-none transition-colors focus:border-cta" />
      <button type="submit" disabled={busy} data-testid="lead-submit-button"
        className="h-14 border border-white/30 px-6 font-display font-medium text-white transition-colors hover:border-white hover:bg-white/5">
        {busy ? <Loader2 size={18} className="animate-spin" /> : "Send me 10% off"}
      </button>
    </form>
    <p className="mt-3 text-xs text-zinc-400" data-testid="lead-consent-note">By signing up you agree to receive emails from First Mover OS. Unsubscribe anytime.</p>
    </div>
  );
};
